<template>
  <div class="fixed top-4 right-4 z-[9999] space-y-3 w-[360px]">
    <transition-group name="toast" tag="div">
      <div
        v-for="n in items"
        :key="n.id"
        class="rounded-lg shadow-lg p-4 border bg-white flex gap-3"
        :class="variantClass(n.variant)"
      >
        <div class="flex-1">
          <div class="font-semibold text-sm">{{ n.title }}</div>
          <div class="text-sm opacity-80 mt-1">{{ n.message }}</div>
          <div v-if="n.meta" class="text-xs opacity-60 mt-2">{{ n.meta }}</div>
        </div>

        <button class="text-sm opacity-60 hover:opacity-100" @click="$emit('close', n.id)">
          ✕
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script>
    export default {
    name: 'ToastStack',
    props: { items: { type: Array, default: () => [] } },
    methods: {
        variantClass(variant) {
        if (variant === 'success') return 'border-green-200'
        if (variant === 'error') return 'border-red-200'
        if (variant === 'warning') return 'border-yellow-200'
        return 'border-blue-200'
        },
    },
    }
</script>

<style scoped>
    .toast-enter-active, .toast-leave-active { transition: all .2s ease; }
    .toast-enter-from, .toast-leave-to { opacity: 0; transform: translateY(-8px); }
</style>
